export default __webpack_public_path__ + "static/media/MT4_activations_XY.a15779fa.png";